export default __webpack_public_path__ + "static/media/international-icon-3x2.10a0fb98.svg";